import { axios } from '@/api/axios.ts';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { TClientNote } from './client-notes.types.ts';

export const clientNotesApi = {
  getNotes: async (clientId: number) => {
    const response = await axios.get<TClientNote[]>(`clients/${clientId}/notes`);

    return response.data;
  },
  createNote: async ({ clientId, body }: { clientId: number; body: string }) => {
    const response = await axios.post<TClientNote>(`clients/${clientId}/notes`, { body });

    return response.data;
  },
  updateNote: async ({ noteId, body }: { noteId: number; body: string }) => {
    const response = await axios.patch<TClientNote>(`clients/notes/${noteId}`, { body });

    return response.data;
  },
  deleteNote: async (noteId: number) => {
    await axios.delete(`clients/notes/${noteId}`);

    return noteId;
  },
};

export const clientNotesQueries = createQueryKeys('clientNotes', {
  getNotes: (clientId: number) => ({
    queryKey: [clientId],
    queryFn: () => clientNotesApi.getNotes(clientId),
  }),
});
